import React, { useEffect } from 'react'

import { useDispatch } from 'react-redux'

import { setDefaultPageAction } from 'actions/system/systemAction'
import { isMamba } from 'common/constants'
import { useShallowEqualSelector } from 'common/hooks/useShallowEqualSelector'
import { indexPath } from 'components/paths'
import { Replace } from 'components/system/Replace'

export const LandingIndex = () => {
  const dispatch = useDispatch()
  const { partnerId } = useShallowEqualSelector(
    ({ systemReducer: { partnerId } }) => ({
      partnerId,
    })
  )
  useEffect(() => {
    return () => {
      dispatch(setDefaultPageAction())
    }
  }, [dispatch])

  if (!isMamba(partnerId)) {
    return <Replace to={indexPath} uid="LandingIndex" />
  }
  return null
}
